export const credentials = {
    username: "dominik",
    password: "Srpanj666$",
  };